import builder from '../builder';
import House3 from '../../streamline-icons/light/house-3.svg';

export default builder('IconHouse3Light', House3);
